import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, ListItemText, Typography } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation('common');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const languages = [
    { code: 'en', label: t('language.en') },
    { code: 'ar', label: t('language.ar') },
  ];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (langCode: string) => {
    if (langCode !== i18n.language) {
      i18n.changeLanguage(langCode);
      window.location.reload();
    }
    handleClose();
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleClick}
        aria-label={t('language.switchLanguage')}
        size="small"
        sx={{ mx: 1, px:1, color: 'var(--an-text-secondary)', backgroundColor: 'var(--an-surface-muted)', border: '1px solid var(--an-border-light)', borderRadius: 'var(--an-radius-sm)', boxShadow: 'var(--an-shadow-xs)', '&:hover': { color: 'var(--an-primary)', backgroundColor: 'var(--an-primary-light)' } }}
      >
        <LanguageIcon />
        <Typography variant="caption" sx={{ ml: 0.5, color: 'inherit', fontWeight: 'bold' }}>
          {i18n.language === 'ar' ? '\u0639' : 'EN'}
        </Typography>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      
        PaperProps={{ sx: { border: '1px solid var(--an-border-light)', boxShadow: 'var(--an-shadow-lg)', borderRadius: 'var(--an-radius-md)' } }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            selected={i18n.language === lang.code}
          >
            <ListItemText>{lang.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
